import { useState, useMemo, useEffect, useRef } from "react";
import { AgGauge } from "ag-charts-react";
import "ag-charts-enterprise";
import { LicenseManager } from "ag-charts-enterprise";
import { AGGRID_LICENCE_KEY, AlertMessagesService, LoaderComponent, Utils } from "../../../../../shared";
import { PlacementDetailsTableService } from "../../../../placements";
import { useNavigate } from "react-router-dom";

LicenseManager.setLicenseKey(AGGRID_LICENCE_KEY);

export default function TaxonomyComplianceCard({ campaignData, orderedData, versionOneApi }) {
  const navigate = useNavigate();
  // const isMountedRef = useRef(false);
  // Light track color for empty space
  const compliance = Number(((orderedData?.total_taxonomy_match/orderedData?.total_placement_count) * 100).toFixed(2)) || 0;
  const isNegative = compliance < 0;
  const trackColor = isNegative ? "rgba(189, 70, 88, 0.15)" : "rgba(45, 212, 191, 0.2)";
  const labelColor = isNegative ? "#BD4658" : "#2DD4BF";
  const options =  {
    // Use red color for negative/low compliance, teal for positive
    
      type: "radial-gauge",
      value: Math.abs(compliance),
      startAngle: 90,
      scale: {
        min: 0,
        max: 100,
        label: {
          enabled: false,
        },
      },
      bar: {
        fills: isNegative 
          ? [{ color: "#E87A8A" }, { color: "#BD4658" }]
          : [{ color: "#5EEAD4" }, { color: "#2DD4BF" }],
        fillMode: "continuous",
      },
      background: {
        fill: 'transparent',
      },
      innerRadiusRatio: 0.8,
      targets: [],
      needle: {
        enabled: false,
      },
      cornerRadius: 99,
      cornerMode: "item",
      label: {
        formatter({ value }) {
          return `${isNegative ? '-' : ''}${Math.round(value)}%`;
        },
        fontSize: 24,
        fontWeight: "600",
        color: labelColor,
      },
      secondaryLabel: {
        enabled: false,
      },
    
  };

  return (
    <div className="taxonomy-compliance-card">
      <div className="card-header">
        <h3 className="card-title">Taxonomy Compliance</h3>
      </div>
      <div className="card-content">
        <div className="chart-container">
          <AgGauge options={options} />
        </div>
      </div>
    </div>
  );
};
